/**
 * **Website → Pictures** — the firm's picture library (FR-I13, ADR-0021,
 * T-4.22; redrawn in Wave 14D — C13, spec §10.5 item 7, T-4.64).
 *
 * The same `MediaBrowser` every image field opens as a picker, in its `manage`
 * mode: a grid of cards, drag-and-drop upload anywhere on the page, where each
 * picture is used, and delete — refused with the reason while a picture is in
 * use, as the service refuses it.
 *
 * **No edit bar** (§10.5 item 3): every action here saves on its own — an
 * upload, a description on blur, a delete after asking — so there is nothing
 * for one Save to send. The page uses `EditPage` for its shell only, so it
 * reads like every other page of the website builder.
 *
 * It also says where the **logo and the browser icon** are set (w8h, finding 2).
 * A firm looking for its logo looks on the screen called Pictures, because a
 * logo is a picture; the fields themselves stay on *How your site looks*, beside
 * the colours and the font they have to sit against. One `ImageField` per site
 * setting, and this library is what both of them open.
 */

import { Sparkles } from 'lucide-react'
import { Link } from 'react-router'

import { EditPage } from '../../components/edit'
import { SITE, useEvaluation } from '../../lib/access'
import { MediaBrowser } from './fields/MediaLibrary'

export function SiteMedia() {
  const { can } = useEvaluation()
  return (
    <EditPage
      title="Pictures"
      description="Every picture you have uploaded for your website. Any picture field in the builder — the hero, the about section, team photographs, a post’s cover — can use one of these."
      back={{ to: '/site', label: 'Your website' }}
    >
      <p className="border-border bg-card text-muted-foreground flex items-start gap-2.5 rounded-xl border px-4 py-3 text-sm">
        <Sparkles size={16} className="text-primary mt-0.5 shrink-0" aria-hidden />
        <span>
          Your <strong className="text-foreground font-medium">logo</strong> and your{' '}
          <strong className="text-foreground font-medium">browser icon</strong> are set on{' '}
          <Link to="/site/theme" className="text-primary font-medium underline-offset-2 hover:underline">
            How your site looks
          </Link>
          , beside the colours and the font they sit against — and they choose from this same library.
        </span>
      </p>
      <MediaBrowser mode="manage" editable={can(SITE, 'can_update')} />
    </EditPage>
  )
}
